/** A portaled dropdown remains part of its owning modal or drawer. */
export function isPortalDropdownTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest('[data-portal-dropdown="true"]') !== null;
}
